import React from "react";
import SystemWheel from "./SystemWheel";

const WhatWeDo = () => {
  return (
    <section className="py-12 md:py-20 relative">
      <div className="w-[90%] max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-5xl">
              Seven systems.<br />
              <span className="text-gold-gradient">One place.</span>
            </h2>
            <p className="mt-5 font-display font-black uppercase tracking-tight leading-tight text-xl sm:text-2xl md:text-[1.75rem]" data-testid="seven-systems-tagline">
              <span className="text-white">Menopause isn't 34 symptoms.</span>
              <br />
              <span style={{ color: "#D4AF35" }}>It's 7 systems.</span>
            </p>
            <div className="mt-6 space-y-5 text-lg text-white/75 leading-relaxed font-medium">
              <p>
                Seven systems shifted at the same time: nutrition, hormones, metabolic, strength,
                recovery, gut, and cardiovascular activity.
              </p>
              <p>Most programs work on a few and leave the rest to you.</p>
              <p>
                We cover all seven. Coaching, training, nutrition, and recovery with us. And when
                you are ready, labs, hormones, and medical oversight through our vetted provider and
                pharmacy partners. We coordinate all of it, so you're not the one chasing it down.
              </p>
              <p className="text-white font-semibold">That's what Full Stack means.</p>
            </div>
          </div>

          <div className="lg:col-span-7 bg-white/[0.03] border border-white/10 rounded-[2rem] p-3 sm:p-6 md:p-8 backdrop-blur-sm">
            <SystemWheel mode="homepage" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
